enum PopupActions {
  ADD_POPUPS = '[popups] Add',
  REMOVE_POPUPS = '[popups] Remove'
}
export default PopupActions
